<template>
    <div class="other-field ">
        <div class="display-flex">
            <div class="label-width">
                <div class="label-icon"><i class="fas fa-comments"></i></div>
                <div class="label-text">Comments</div>
            </div>
            <div class="label-field comments no-bg">
                <div class="what-info">Do you need a translation or have any question? Ask us here!</div>
                <div class="box" v-bind:class="{ 'incoming': comment.user.name != getUserName }" v-if="isAdmin" v-for="comment in comments">
                    <article class="media">
                        <div class="media-content">
                            <div class="content">
                                <p>
                                    <strong>{{ comment.user.name }}</strong> <small>@</small> <small>{{ comment.created_at }}</small> <small class="link" @click="replyTo(comment.user)"><i class="fas fa-reply"></i></small>
                                    <br>
                                    {{ comment.body }}
                                </p>
                            </div>
                        </div>
                    </article>
                </div>
                <div class="box" v-bind:class="{ 'incoming': comment.user.name != getUserName }" v-for="comment in comments" v-if="!isAdmin && showComment(comment)">
                    <article class="media">
                        <div class="media-content">
                            <div class="content">
                                <p>
                                    <strong>{{ comment.user.name }}</strong> <small>@</small> <small>{{ comment.created_at }}</small> <small class="link" @click="replyTo(comment.user)"><i class="fas fa-reply"></i></small>
                                    <br>
                                    {{ comment.body }}
                                </p>
                            </div>
                        </div>
                    </article>
                </div>
                <textarea class="textarea" rows="1" placeholder="Type your comment." v-model="comment.body"></textarea>

            </div>
        </div>
        <div class="other-button text-center">
            <button class="button is-primary"
                    v-bind:class="{ 'is-loading': isLoading }"
                    @click="postComment()">Post comment</button>
            <p class="link" @click="removeReplay()" v-if="comment.reply_to.length > 0">Reply to: {{ replyName }} <i class="fas fa-times"></i></p>
        </div>
    </div>
</template>

<script>
    import commentsApi from './../../../api/apiComments.js'
    export default {
        props: ['lot'],
        data () {
            return {
                isLoading: false,
                query: {
                 lot_id: this.lot.lot_id
                },
                comment: {
                    lot_id: this.lot.lot_id,
                    body: '',
                    reply_to: ''
                },
                comments: [],
                replyName: '',
            }
        },
        created () {
            commentsApi
                .getThreatRequest(this.query)
                .then((response) => {
                    if (response.data.comments){
                        this.comments = response.data.comments
                    }
                })
                .catch(error => console.log(error))
        },
        methods: {
            replyTo(user) {
                this.comment.reply_to = user.email
                this.replyName = user.name
            },
            removeReplay() {
                this.comment.reply_to = ''
                this.replyName = ''
            },
            postComment() {
                this.isLoading = true
                commentsApi
                    .createCommentRequest(this.comment)
                    .then((response) => {
                        this.comment.body = ''
                        this.comments.push(response.data[0])
                        this.isLoading = false
                        this.removeReplay()
                    })
                    .catch(error => console.log(error))
            },
            showComment(comment) {
                if (comment.user.roles[0].name === 'Admin') {
                    return true
                } else {
                    return comment.user.name === this.$store.getters.getUserName
                }

            }
        },
        computed: {
            isAdmin() {
                if (this.$store.getters.getUserRole === 'Admin') {
                    return true
                }
            },
            getUserName() {
                return this.$store.getters.getUserName;
            },
            currentUser() {
                return this.$store.getters.getCurrentUser;
            }
        }
    }
</script>

<style scoped>
    .link:hover {
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/Auctions/Lot/CommentsBox.vue